class QueryKeys {
	static forWorkspaceMembers( { workspaceID }: { workspaceID: number } ) {
		return [ 'workspaces', workspaceID, 'members' ];
	}
}

export { QueryKeys };
